import { useState } from 'react'
import type { Transaction } from '../api/types'
import { PayActions } from './PayActions'

export const MIN_CREDITS = 3
export const MAX_CREDITS = 10000

/** Legacy buy-credit widget (payment-credit-view modal and the
 * paymentmethod-change "Buy credit" tab): a whole number of credits
 * between 3 and 10000; 1 credit = USD 1 (the legacy page hard-coded the
 * "USD" label the same way). The count travels as a string. */
export function BuyCredit({
  projectId,
  hasPaymentMethod,
  onCharged,
  newMethodOnly,
}: {
  projectId: string
  hasPaymentMethod: boolean
  onCharged: (tx: Transaction | null) => void
  newMethodOnly?: boolean
}) {
  const [count, setCount] = useState(String(MIN_CREDITS))
  const n = /^\d+$/.test(count.trim()) ? Number(count.trim()) : NaN
  const valid = n >= MIN_CREDITS && n <= MAX_CREDITS
  return (
    <div className="fs-panel">
      <h3>Buy credit</h3>
      <label className="portal-input-group">
        <span>Credits</span>
        <input
          type="number"
          min={MIN_CREDITS}
          max={MAX_CREDITS}
          step={1}
          aria-label="Credits to buy"
          value={count}
          onChange={(e) => setCount(e.target.value)}
        />
        <input
          type="range"
          min={MIN_CREDITS}
          max={MAX_CREDITS}
          aria-label="Credits to buy slider"
          value={valid ? n : MIN_CREDITS}
          onChange={(e) => setCount(e.target.value)}
        />
      </label>
      {valid ? (
        <p className="fs-amount">Total to pay: USD {count.trim()}</p>
      ) : (
        <p role="alert" className="portal-notice portal-notice--warning">
          Please enter an amount between {MIN_CREDITS} and {MAX_CREDITS}!
        </p>
      )}
      <PayActions
        projectId={projectId}
        target={{ type: 'credit', credits: count.trim(), creditCurrency: 'credit' }}
        hasPaymentMethod={hasPaymentMethod}
        onCharged={onCharged}
        disabled={!valid}
        newMethodOnly={newMethodOnly}
      />
    </div>
  )
}
